export const getAllCampaigns = (state) => state.allCampaigns;
